"use-strict";

export const UPDATE_APP_DATA = "UPDATE_APP_DATA";
export const UPDATE_BRAND_USER_DATA = "UPDATE_BRAND_USER_DATA";
export const UPDATE_ORG_DATA = "UPDATE_ORG_DATA";
export const UPDATE_BRAND_DATA = "UPDATE_BRAND_DATA";
export const UPDATE_BRAND_USER_AUTH = "UPDATE_BRAND_USER_AUTH";
export const UPDATE_ADMIN_DATA = "UPDATE_ADMIN_DATA";
